<template lang="pug">
div
  section.u-mt-md
    AppTitle.u-mb-0(:title="$t('mantra')")

  .u-mb-md


</template>

<script>
export default {
  head() {
    const $t = this.$t.bind(this);
    return {
      title: $t('pageTitle'),
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: $t('pageTitle')
        },
        {
          hid: 'description',
          name: 'description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: $t('pageDesc')
        }
      ]
    };
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Baianat partners",
    "pageDesc":"Partners we are proud to share the journey with in Baianat.",
    "mantra":"Official partners |and collaborators."
  },
  "ar": {
    "pageTitle":"الشركاء",
    "pageDesc":"شركاء نفخر بمشاركتهم رحلتنا في بيانات.",
    "mantra":"الشركاء الرسميون |لبيانات. "
  }
}
</i18n>
